import type { ReactNode, Ref } from 'react';
import type { TextProps as AriaTextProps } from 'react-aria-components';
import { Text as AriaText } from 'react-aria-components';

import { cx } from '@/utils/cx';

interface HintTextProps extends AriaTextProps {
  /** Indicates that the hint text is an error message. */
  isInvalid?: boolean;
  /** Controls whether error styling is shown. When false, suppresses error UI even if isInvalid is true. */
  showError?: boolean;
  ref?: Ref<HTMLElement>;
  children: ReactNode;
  className?: string;
}

export const HintText = ({
  isInvalid,
  showError,
  className,
  ...props
}: HintTextProps) => {
  const effectiveInvalid = isInvalid && showError !== false;
  return (
    <AriaText
      {...props}
      slot={effectiveInvalid ? 'errorMessage' : 'description'}
      className={cx(
        'text-sm text-tertiary',

        // Invalid state
        effectiveInvalid && 'text-error-primary',
        'group-invalid:text-error-primary',

        className
      )}
    />
  );
};

HintText.displayName = 'HintText';
